import {StatusBarStyle} from 'react-native';
import Styles from 'src/components/Styles';

export function statusBarStyleDescriptor(): StatusBarStyle {
  return 'dark-content';
}

export function statusBarBackgroundColorDescriptor(): string {
  return Styles.transparent;
}

export function welcomeScreenstatusBarStyleDescriptor(): StatusBarStyle {
  return 'dark-content';
}

export default {
  statusBarStyleDescriptor,
  statusBarBackgroundColorDescriptor,
  welcomeScreenstatusBarStyleDescriptor,
};
